import { render, staticRenderFns } from "./PersonalData.vue?vue&type=template&id=42ca1344&scoped=true&"
var script = {}
import style0 from "./PersonalData.vue?vue&type=style&index=0&id=42ca1344&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42ca1344",
  null
  
)

export default component.exports